import {Key, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useHistory} from 'react-router';
import {Link, RouteComponentProps} from 'react-router-dom';

import HeaderLightComponent from '../component/header/HeaderLightComponent';
import FooterComponent from '../component/footer/FooterComponent';
import storage from '../util/storage';
import CreateUseCase from '../../useCase/Folder/CreateUseCase';
import FetchFolderGateway from '../../gateway/Folder/FetchFolderGateway';
import FormGateway from '../../gateway/Form/FormGateway';
import GetFormsUseCase from '../../useCase/Form/GetFormsUseCase';

import SignedFiles from '../component/svg/SignedFiles';
import SignatureFiles from '../component/svg/SignatureFiles';
import CurrentCases from '../component/svg/CurrentCases';
import AbandonedFiles from '../component/svg/AbandonedFiles';
import SynchroPending from '../component/svg/SynchroPending'
import SynchroSuccess from '../component/svg/SynchroSuccess'
import ToValidate from '../component/svg/ToValidate'
import SynchroError from '../component/svg/SynchroError'
import SynchroRefused from '../component/svg/SynchroRefused'

import '../../assets/styles/components/_dashboard.scss'
import envVariable, { isManualRegistrationEnabled } from '../util/envVariable'
import { ERole, roleBackOfficeList } from '../../domain/User/Erole';
import {Tab, Tabs} from '../component/tab/Tab'
import { EModule } from '../../domain/User/Emodule';

interface Params {
  currentTab: string
}

const Dashboard = ({match}: RouteComponentProps<Params>): JSX.Element => {
  const {t} = useTranslation()
  const history = useHistory()

  const [role] = useState<string>(storage.getRole());
  const [signedFiles, setSignedFiles] = useState<number>(0);
  const [signatureFiles, setSignatureFiles] = useState<number>(0);
  const [currentCases, setCurrentCases] = useState<number>(0);
  const [abandonedFiles, setAbandonedFiles] = useState<number>(0);
  const [signedToSync, setSignedToSync] = useState<number>(0);
  const [signedValidated, setSignedValidated] = useState<number>(0);
  const [signedSyncError, setSignedSyncError] = useState<number>(0);
  const [signedSync, setSignedSync] = useState<number>(0);
  const [signedSyncRefused, setSignedSyncRefused] = useState<number>(0);
  const [signedSyncWaiting, setSignedSyncWaiting] = useState<number>(0);
  const [platformOnGoing, setPlatformOnGoing] = useState<number>(0);
  const [platformValidated, setPlatformValidated] = useState<number>(0);
  const [platformRefused, setPlatformRefused] = useState<number>(0);
  const [platformWating, setPlatformWating] = useState<number>(0);
  const userProfile = storage.getUserInformation()
  const [correctionAsked, setCorrectionAsked] = useState<number>(0);
  const [preSignatureValidationFiles, setPreSignatureValidationFiles] = useState<number>(0)
  const [hasConventionForm, setHasConventionForm] = useState<boolean>(false)

  useEffect(() => {
    (new FetchFolderGateway()).retrieveNumberDossiersByState().then(numberDossiersByState => {
        if (null !== numberDossiersByState) {
          setSignedFiles(numberDossiersByState.signed)
          setSignatureFiles(numberDossiersByState.signature)
          setCurrentCases(numberDossiersByState.current)
          setAbandonedFiles(numberDossiersByState.abandoned)
          setSignedToSync(numberDossiersByState.signed_ongoing)
          setSignedValidated(numberDossiersByState.signed_validated)
          setSignedSyncError(numberDossiersByState.signed_error)
          setSignedSync(numberDossiersByState.signed_sync)
          setSignedSyncRefused(numberDossiersByState.signed_refused)
          setSignedSyncWaiting(numberDossiersByState.signed_waiting)
          setPlatformOnGoing(numberDossiersByState.platform_ongoing)
          setPlatformValidated(numberDossiersByState.platform_validated)
          setPlatformRefused(numberDossiersByState.platform_refused)
          setPlatformWating(numberDossiersByState.platform_waiting)
          setCorrectionAsked(numberDossiersByState.correction_asked)
          setPreSignatureValidationFiles(numberDossiersByState.pre_signature_validation)
        }
      }
    )
  }, [])

  useEffect(() => {
    if (role !== ERole.Back_office_user) {
      return
    }
    const conventionFormId = storage.getBackOfficeConventionFormId()
    new GetFormsUseCase(new FormGateway()).execute().then(forms => {
      setHasConventionForm(forms.some(form => form.id === conventionFormId))
    })
  }, [role])

  const createUseCase = new CreateUseCase(new FetchFolderGateway());

  function createFileWithoutClient() {
    createUseCase.execute(storage.getClientFormId(), null)
      .then((newFolderId) => {
        history.push(`/dossier/${newFolderId}/form/`)
      })
  }

  function manualSubscriptionRegistration() {
    createUseCase.execute(storage.getBackOfficeFormId(), null)
      .then((newFolderId) => {
        history.push(`/dossier/${newFolderId}/form/`)
      })
  }

  function createConvention() {
    createUseCase.execute(storage.getBackOfficeConventionFormId(), null)
      .then((newFolderId) => {
        history.push(`/dossier/${newFolderId}/form/`)
      })
  }

  const userRole = localStorage.getItem('role');
  const isBackOfficeUser = (userRole && roleBackOfficeList.includes(userRole));
  const keyTab = match?.params?.currentTab !== undefined
    ? match.params.currentTab : (role === ERole.ManageDossier
      ? 'integration' : userProfile?.modules?.includes(EModule.PlatformValidator)
        ? 'platform' : 'gestion'
    )

  const onTabChange = (index: number, key: Key|null) => {
    if (index === 0) {
      localStorage.setItem("previousPage", `/tableau-de-bord/gestion/`);
      history.push(`/tableau-de-bord/gestion/`, { from: `/tableau-de-bord/gestion/` })
    } else if (role === ERole.ManageDossier) {
      localStorage.setItem("previousPage", `/tableau-de-bord/integration/`);
      history.push(`/tableau-de-bord/integration/`, { from: `/tableau-de-bord/integration/` })
    } else if (userProfile?.modules?.includes(EModule.PlatformValidator)) {
      localStorage.setItem("previousPage", `/tableau-de-bord/plateforme/`);
      history.push(`/tableau-de-bord/plateforme/`, { from: `/tableau-de-bord/plateforme/` })
    }
  };

  return <>
    <HeaderLightComponent />
    <>
      <div className="wrap u-mxAuto">
        <div className="flex-container">
          <div className="col-md-12">
            <h2 className="h3 help-wrapper u-mbs">{t('dashboard.title')}</h2>
          </div>
        </div>
      </div>
      {role === ERole.ManageDossier &&
        <Tabs active={keyTab === 'gestion' ? 0 : 1} onTabChange={onTabChange} classes={'wrap u-mxAuto'} tabClass='col-md-3 mb-0' tabButtonClass={'button-tab button-folder button-tab-white'}>
          [
          <Tab key={0} label={t('dashboard.tabs.manage')}>
            <div className="min-height-content">
              <div className="box-elevations box-elevations--base box-elevations--max-heigt-initial box-elevations--mb u-mxAuto br-tl-0">
                  <div className="flex-container heading-folder-cta">
                    {isManualRegistrationEnabled() &&
                      <>
                        <div className="col-md-12">
                          <div className="button__container">
                            <a href="#" onClick={() => manualSubscriptionRegistration()}
                              className="create-folder-prospect button button-primary button--large button--width-full">{t('folder.register-folder')}</a>
                          </div>
                        </div>
                      </>
                    }
                  </div>
                <div className="dashboard__filters">
                  <>
                    <Link to={`/dossiers/signed-files`} className="dashboard__filter dashboard__filter__signed">
                      <div className="filter__icon"><SignedFiles color="var(--ink-1)"/></div>
                      <div className="filter__number">{signedFiles}</div>
                      <div className="filter__label" dangerouslySetInnerHTML={{__html: t('dashboard.signed-files')}}/>
                    </Link>
                    <Link to={`/dossiers/signature-files`} className="dashboard__filter dashboard__filter__signature">
                      <div className="filter__icon"><SignatureFiles color="var(--ink-1)"/></div>
                      <div className="filter__number">{signatureFiles}</div>
                      <div className="filter__label" dangerouslySetInnerHTML={{__html: t('dashboard.signature-files')}}/>
                    </Link>
                    <Link to={`/dossiers/current-cases`} className="dashboard__filter  dashboard__filter__current-cases">
                      <div className="filter__icon"><CurrentCases color="var(--ink-1)"/></div>
                      <div className="filter__number">{currentCases}</div>
                      <div className="filter__label" dangerouslySetInnerHTML={{__html: t('dashboard.current-cases')}}/>
                    </Link>
                    <Link to={`/dossiers/abandoned-files`} className="dashboard__filter  dashboard__filter__abandonned-files">
                      <div className="filter__icon"><AbandonedFiles color="var(--ink-1)"/></div>
                      <div className="filter__number">{abandonedFiles}</div>
                      <div className="filter__label" dangerouslySetInnerHTML={{__html: t('dashboard.abandoned-files')}}/>
                    </Link>
                    { correctionAsked > 0 &&
                      <Link to={`/dossiers/correction`} className="dashboard__filter  dashboard__filter__error">
                        <div className="filter__icon"><SynchroError color="var(--ink-1)" /></div>
                        <div className="filter__number">{correctionAsked}</div>
                        <div className="filter__label" dangerouslySetInnerHTML={{ __html: t('dashboard.correction') }} />
                      </Link>
                    }
                  </>
                </div>
              </div>
            </div>
          </Tab>
          ]
          [
          <Tab key={1} label={t('dashboard.tabs.integration')}>
            <>
              <div className="min-height-content">
                <div className="box-elevations box-elevations--base box-elevations--max-heigt-initial box-elevations--mb u-mxAuto br-tl-0">
                  <div className="dashboard__filters">
                    <Link to={`/manage-dossier/statut-integration/ongoing`} className="dashboard__filter dashboard__filter__ongoing">
                      <div className="filter__icon"><ToValidate color="var(--ink-1)" /></div>
                      <div className="filter__number">{signedToSync}</div>
                      <div className="filter__label" dangerouslySetInnerHTML={{ __html: t('dashboard.integration-state.ongoing') }} />
                    </Link>
                    <Link to={`/manage-dossier/statut-integration/validated`} className="dashboard__filter  dashboard__filter__validated">
                      <div className="filter__icon"><SynchroPending color="var(--ink-1)" /></div>
                      <div className="filter__number">{signedValidated}</div>
                      <div className="filter__label" dangerouslySetInnerHTML={{ __html: t('dashboard.integration-state.validated') }} />
                    </Link>
                    <Link to={`/manage-dossier/statut-integration/sync`} className="dashboard__filter  dashboard__filter__sync">
                      <div className="filter__icon"><SynchroSuccess color="var(--ink-1)" /></div>
                      <div className="filter__number">{signedSync}</div>
                      <div className="filter__label" dangerouslySetInnerHTML={{ __html: t('dashboard.integration-state.sync') }} />
                    </Link>
                    <Link to={`/manage-dossier/statut-integration/error`} className="dashboard__filter  dashboard__filter__error">
                      <div className="filter__icon"><SynchroError color="var(--ink-1)" /></div>
                      <div className="filter__number">{signedSyncError}</div>
                      <div className="filter__label" dangerouslySetInnerHTML={{ __html: t('dashboard.integration-state.error') }} />
                    </Link>
                    <Link to={`/manage-dossier/statut-integration/refused`} className="dashboard__filter  dashboard__filter__refused">
                      <div className="filter__icon"><SynchroRefused color="var(--ink-1)" /></div>
                      <div className="filter__number">{signedSyncRefused}</div>
                      <div className="filter__label" dangerouslySetInnerHTML={{ __html: t('dashboard.integration-state.refused') }} />
                    </Link>
                    <Link to={`/manage-dossier/statut-integration/waiting`} className="dashboard__filter  dashboard__filter__refused opacity-50">
                      <div className="filter__icon"><SynchroRefused color="var(--ink-1)" /></div>
                      <div className="filter__number">{signedSyncWaiting}</div>
                      <div className="filter__label" dangerouslySetInnerHTML={{ __html: t('dashboard.integration-state.waiting') }} />
                    </Link>
                  </div>
                </div>
              </div>
            </>
          </Tab>
          ]
        </Tabs>
      }
      {userProfile?.modules?.includes(EModule.PlatformValidator) && role !== ERole.ManageDossier && role !== ERole.Back_office_user &&
        <Tabs active={keyTab === 'gestion' ? 0 : 1} onTabChange={onTabChange} classes={'wrap u-mxAuto'} tabClass='col-md-3 mb-0' tabButtonClass={'button-tab button-folder button-tab-white'}>
          [
          <Tab key={0} label={t('dashboard.tabs.manage')}>
            <div className="min-height-content">
              <div className="box-elevations box-elevations--base box-elevations--max-heigt-initial box-elevations--mb u-mxAuto br-tl-0">
                <div className={`h4 help-wrapper u-mbs title-create-folder`}>{t('folder.create-for')}</div>
                <div className="flex-container heading-folder-cta">
                  <>
                    <div className="col-md-6">
                      <div className="button__container">
                        <Link to={'/creer-un-dossier-client'}
                          className="create-folder button button-primary button--large button--width-full">
                          {t(envVariable('REACT_APP_VARIABLES_CREATE_FOLDER_CUSTOMER_BUTTON', 'folder.create-customer'))}
                        </Link>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="button__container">
                        <a href="#" onClick={() => createFileWithoutClient()}
                          className="create-folder-prospect button button-primary button--large button--width-full">
                          {t(envVariable('REACT_APP_VARIABLES_CREATE_FOLDER_LEAD_BUTTON', 'folder.create-lead'))}
                        </a>
                      </div>
                    </div>
                  </>
                </div>
                <div className="dashboard__filters">
                  <>
                    <Link to={`/dossiers/signed-files`} className="dashboard__filter dashboard__filter__signed">
                      <div className="filter__icon"><SignedFiles color="var(--ink-1)" /></div>
                      <div className="filter__number">{signedFiles}</div>
                      <div className="filter__label" dangerouslySetInnerHTML={{ __html: t('dashboard.signed-files') }} />
                    </Link>
                    <Link to={`/dossiers/signature-files`} className="dashboard__filter dashboard__filter__signature">
                      <div className="filter__icon"><SignatureFiles color="var(--ink-1)" /></div>
                      <div className="filter__number">{signatureFiles}</div>
                      <div className="filter__label" dangerouslySetInnerHTML={{ __html: t('dashboard.signature-files') }} />
                    </Link>
                    <Link to={`/dossiers/current-cases`} className="dashboard__filter  dashboard__filter__current-cases">
                      <div className="filter__icon"><CurrentCases color="var(--ink-1)" /></div>
                      <div className="filter__number">{currentCases}</div>
                      <div className="filter__label" dangerouslySetInnerHTML={{ __html: t('dashboard.current-cases') }} />
                    </Link>
                    <Link to={`/dossiers/abandoned-files`} className="dashboard__filter  dashboard__filter__abandonned-files">
                      <div className="filter__icon"><AbandonedFiles color="var(--ink-1)" /></div>
                      <div className="filter__number">{abandonedFiles}</div>
                      <div className="filter__label" dangerouslySetInnerHTML={{ __html: t('dashboard.abandoned-files') }} />
                    </Link>
                    {correctionAsked > 0 &&
                      <Link to={`/dossiers/correction`} className="dashboard__filter  dashboard__filter__error">
                        <div className="filter__icon"><SynchroError color="var(--ink-1)" /></div>
                        <div className="filter__number">{correctionAsked}</div>
                        <div className="filter__label" dangerouslySetInnerHTML={{ __html: t('dashboard.correction') }} />
                      </Link>
                    }
                  </>
                </div>
              </div>
            </div>
          </Tab>
          ]
          [
          <Tab key={1} label={t('dashboard.tabs.plateforme')}>
            <>
              <div className="min-height-content">
                <div className="box-elevations box-elevations--base box-elevations--max-heigt-initial box-elevations--mb u-mxAuto br-tl-0">
                  <div className="dashboard__filters">
                    <Link to={`/plateforme-dossier/statut-plateforme/ongoing`} className="dashboard__filter dashboard__filter__ongoing">
                      <div className="filter__icon"><ToValidate color="var(--ink-1)" /></div>
                      <div className="filter__number">{platformOnGoing}</div>
                      <div className="filter__label" dangerouslySetInnerHTML={{ __html: t('dashboard.plateforme-state.ongoing') }} />
                    </Link>
                    <Link to={`/plateforme-dossier/statut-plateforme/validated`} className="dashboard__filter  dashboard__filter__validated">
                      <div className="filter__icon"><SynchroPending color="var(--ink-1)" /></div>
                      <div className="filter__number">{platformValidated}</div>
                      <div className="filter__label" dangerouslySetInnerHTML={{ __html: t('dashboard.plateforme-state.validated') }} />
                    </Link>
                    <Link to={`/plateforme-dossier/statut-plateforme/refused`} className="dashboard__filter  dashboard__filter__refused">
                      <div className="filter__icon"><SynchroRefused color="var(--ink-1)" /></div>
                      <div className="filter__number">{platformRefused}</div>
                      <div className="filter__label" dangerouslySetInnerHTML={{ __html: t('dashboard.plateforme-state.refused') }} />
                    </Link>
                    {platformWating > 0 &&
                      <Link to={`/plateforme-dossier/statut-plateforme/waiting`} className="dashboard__filter  dashboard__filter__refused opacity-50">
                        <div className="filter__icon"><CurrentCases color="var(--ink-1)" /></div>
                        <div className="filter__number">{platformWating}</div>
                        <div className="filter__label" dangerouslySetInnerHTML={{ __html: t('dashboard.plateforme-state.waiting') }} />
                      </Link>
                    }
                  </div>
                </div>
              </div>
            </>
          </Tab>
          ]
        </Tabs>
      }
      {role !== ERole.ManageDossier && (!userProfile?.modules?.includes(EModule.PlatformValidator) || role === ERole.Back_office_user) &&
        <div className="min-height-content">
          <div className="box-elevations box-elevations--base box-elevations--max-heigt-initial box-elevations--mb u-mxAuto">
            {((role !== 'client' && role !== 'prospect_direct' && role !== 'prospect' && !isBackOfficeUser) || (role == 'prospect_direct')) &&
              <div className={`h4 help-wrapper u-mbs title-create-folder`}>{t('folder.create-for')}</div>
            }
            <div className="flex-container heading-folder-cta">
              {role !== 'client' && role !== 'prospect_direct' && role !== 'prospect' && !isBackOfficeUser &&
                <>
                  <div className="col-md-6">
                    <div className="button__container">
                      <Link to={'/creer-un-dossier-client'}
                            className="create-folder button button-primary button--large button--width-full">
                        {t(envVariable('REACT_APP_VARIABLES_CREATE_FOLDER_CUSTOMER_BUTTON', 'folder.create-customer'))}
                      </Link>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="button__container">
                      <a href="#" onClick={() => createFileWithoutClient()}
                        className="create-folder-prospect button button-primary button--large button--width-full">
                        {t(envVariable('REACT_APP_VARIABLES_CREATE_FOLDER_LEAD_BUTTON', 'folder.create-lead'))}
                      </a>
                    </div>
                  </div>
                </>
              }
              {role == ERole.DirectProspect &&
                <>
                  <div className="col-md-12">
                    <div className="button__container">
                      <a href="#" onClick={() => createFileWithoutClient()}
                        className="create-folder-prospect button button-primary button--large button--width-full">{t('folder.create-folder')}</a>
                    </div>
                  </div>
                </>
              }
              {role == ERole.Back_office_user && hasConventionForm &&
                <div className="col-md-12">
                  <div className="button__container">
                    <a href="#" onClick={() => createConvention()} className="create-folder button button-primary button--large button--width-full">
                      {t(envVariable('REACT_APP_VARIABLES_CREATE_FOLDER_CONVENTION_BUTTON', 'folder.create-convention'))}
                    </a>
                  </div>
                </div>
              }
            </div>
            <div className="dashboard__filters">
              <Link to={`/dossiers/signed-files`} className="dashboard__filter dashboard__filter__signed">
                <div className="filter__icon"><SignedFiles color="var(--ink-1)"/></div>
                <div className="filter__number">{signedFiles}</div>
                <div className="filter__label" dangerouslySetInnerHTML={{__html: t('dashboard.signed-files')}}/>
              </Link>
              <Link to={`/dossiers/signature-files`} className="dashboard__filter dashboard__filter__signature">
                <div className="filter__icon"><SignatureFiles color="var(--ink-1)"/></div>
                <div className="filter__number">{signatureFiles}</div>
                <div className="filter__label" dangerouslySetInnerHTML={{__html: t('dashboard.signature-files')}}/>
              </Link>
              <Link to={`/dossiers/current-cases`} className="dashboard__filter  dashboard__filter__current-cases">
                <div className="filter__icon"><CurrentCases color="var(--ink-1)"/></div>
                <div className="filter__number">{currentCases}</div>
                <div className="filter__label" dangerouslySetInnerHTML={{__html: t('dashboard.current-cases')}}/>
              </Link>
              <Link to={`/dossiers/abandoned-files`} className="dashboard__filter  dashboard__filter__abandonned-files">
                <div className="filter__icon"><AbandonedFiles color="var(--ink-1)"/></div>
                <div className="filter__number">{abandonedFiles}</div>
                <div className="filter__label" dangerouslySetInnerHTML={{__html: t('dashboard.abandoned-files')}}/>
              </Link>
              {correctionAsked > 0 && (!userProfile?.modules?.includes(EModule.PlatformValidator) && (role === ERole.Client || role === ERole.Prospect || role === ERole.Advisor || role === ERole.Partner || role === ERole.DirectProspect)) &&
                <Link to={`/dossiers/correction`} className="dashboard__filter  dashboard__filter__error">
                  <div className="filter__icon"><SynchroError color="var(--ink-1)" /></div>
                  <div className="filter__number">{correctionAsked}</div>
                  <div className="filter__label" dangerouslySetInnerHTML={{ __html: t('dashboard.correction') }} />
                </Link>
              }
              {correctionAsked > 0 && (!userProfile?.modules?.includes(EModule.PreSignatureValidator) && (role === ERole.Back_office_user)) &&
                <Link to={`/dossiers/correction`} className="dashboard__filter  dashboard__filter__error">
                  <div className="filter__icon"><SynchroError color="var(--ink-1)" /></div>
                  <div className="filter__number">{correctionAsked}</div>
                  <div className="filter__label" dangerouslySetInnerHTML={{ __html: t('dashboard.correction') }} />
                </Link>
              }
              {correctionAsked > 0 && (userProfile?.modules?.includes(EModule.PreSignatureValidator) && (role === ERole.Back_office_user)) &&
                <Link to={`/dossiers/correction`} className="dashboard__filter  dashboard__filter__error">
                  <div className="filter__icon"><SynchroError color="var(--ink-1)" /></div>
                  <div className="filter__number">{correctionAsked}</div>
                  <div className="filter__label" dangerouslySetInnerHTML={{ __html: t('dashboard.pre-signature-validation-pending') }} />
                </Link>
              }
              {userProfile?.modules?.includes(EModule.PreSignatureValidator) && role === ERole.Back_office_user &&
                <Link to={`/pre-signature-validation`} className="dashboard__filter  dashboard__filter__ongoing">
                  <div className="filter__icon"><ToValidate color="var(--ink-1)" /></div>
                  <div className="filter__number">{preSignatureValidationFiles}</div>
                  <div className="filter__label" dangerouslySetInnerHTML={{ __html: t('dashboard.pre-signature-validation') }} />
                </Link>
              }
            </div>
          </div>
        </div>
      }
      </>
    <FooterComponent />
  </>
}

export default Dashboard;
